export default __webpack_public_path__ + "static/media/Group 20.c6ef888c.png";